'use client'
import { CardContent, CardTitle } from '@/ui/card'
import { Form, FormField } from '@/ui/form'
import { Dto, FormReturn } from '../model/types/hypotheses-filter'
import { fieldNames } from '@/shared/constants/field-names'
import { DictionaryCheckboxSelectShowMore, DictionaryMutlipleSelect } from '@/entities/dictionary'

export interface FormProps extends FormReturn {
  onSubmit?: (v: Dto) => void
  loading?: boolean
}

export default function FormComponent({ onSubmit, loading, ...form }: FormProps) {
  return (
    <>
      <Form {...form}>
        <form onSubmit={onSubmit ? form.handleSubmit(onSubmit) : () => {}} className="flex flex-col gap-4 w-full">
          <CardContent className="px-0 flex flex-col gap-y-[20px] pb-2 w-full rounded-[10px]">
            <FormField
              control={form.control}
              name={fieldNames.HYPOTHESES_FILTER_TOOL}
              render={({ field }) => {
                return (
                  <div className="flex flex-col gap-1 w-full">
                    <CardTitle className="text-md">Инструменты</CardTitle>
                    <DictionaryCheckboxSelectShowMore
                      dictionary={(d) => d.hypotheses.tools}
                      onChange={field.onChange}
                      values={field.value}
                      showMoreProps={{ defaultVisibleItems: 2 }}
                    />
                  </div>
                )
              }}
            />

            <FormField
              control={form.control}
              name={fieldNames.HYPOTHESES_FILTER_MARK}
              render={({ field }) => {
                return (
                  <div className="flex flex-col gap-1 w-full">
                    <CardTitle className="text-md">Показатель для оценки гипотез</CardTitle>

                    <DictionaryCheckboxSelectShowMore
                      dictionary={(d) => d.hypotheses.marks}
                      onChange={field.onChange}
                      values={field.value}
                      showMoreProps={{ defaultVisibleItems: 2 }}
                    />
                  </div>
                )
              }}
            />

            <FormField
              control={form.control}
              name={fieldNames.HYPOTHESES_FILTER_MARK_TYPE}
              render={({ field }) => {
                return (
                  <div className="flex flex-col gap-1 w-full">
                    <CardTitle className="text-md">Единица измерения показателя</CardTitle>
                    <DictionaryMutlipleSelect
                      dictionary={(d) => d.hypotheses.mark_types}
                      onChange={field.onChange}
                      badgeButtonProps={{
                        variant: 'defaultOutline',
                      }}
                      selected={field.value}
                      labelField="name"
                    />
                  </div>
                )
              }}
            />

            <FormField
              control={form.control}
              name={fieldNames.HYPOTHESES_FILTER_KIND}
              render={({ field }) => {
                return (
                  <div className="flex flex-col gap-1 w-full">
                    <CardTitle className="text-md">Объект исследования гипотезы</CardTitle>
                    <DictionaryMutlipleSelect
                      dictionary={(d) => d.hypotheses.kinds}
                      onChange={field.onChange}
                      badgeButtonProps={{
                        variant: 'defaultOutline',
                      }}
                      selected={field.value}
                    />
                  </div>
                )
              }}
            />
          </CardContent>
        </form>
      </Form>
    </>
  )
}
